import { styled } from '@linaria/react';
import { PaginationButton } from '../shared/Button.styles';

export const ProductHeaderWrapper = styled.div`
    padding: 0;
    margin-bottom: 1rem;
`;

export const NavigationBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
`;

export const BackButton = PaginationButton;
export const PrintButton = PaginationButton;

export const ProductTitleSection = styled.div``;

export const ProductTitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
`;

export const TitleLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    flex: 0 0 70%;
    max-width: 70%;
`;

export const TitleRight = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    flex: 0 0 30%;
    max-width: 30%;
`;

export const ProductHeadingTitle = styled.div`
    font-size: 2.25rem;
    font-weight: 700;
    color: #2c3e50;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    line-height: 1.2;

    .default-product-label {
        color: #6c757d;
        font-weight: 400;
        font-size: 1.2rem;
    }
`;

export const ProductSymbolsRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const ButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;
